import * as ActionType from "./slider.type";

const initialState = {
  slider: [],
};

export const sliderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SLIDER:
      return {
        ...state,
        slider: action.payload,
      };

    case ActionType.UPDATE_SLIDER:
      return {
        ...state,
        slider: state.slider.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
      };

    case ActionType.DELETE_SLIDER:
      return {
        ...state,
        slider: state.slider.filter(
          (data) => data._id !== action.payload && data
        ),
      };

    case ActionType.CREATE_SLIDER:
      let data = [...state.slider];
      data.unshift(action.payload);
      return {
        ...state,
        slider: data,
      };

    default:
      return state;
  }
};
